import { createTemplate, getTemplates, deleteTemplate, updateTemplate } from '../services/Api';

const create = async ( templateData ) => {
    try {
        const response = await createTemplate( templateData );
        return response;
    } catch (err) {
        console.log("err to save template "+ err)
        return null;
    }
};

const getTemplatesFromDatabase = async () => {
    try {
        const response = await getTemplates();
        return response;
    } catch (err) {
        console.log("err to get templates "+ err)
        return null;
    }
};

const deleteTemplateFromDatabase = async ( id ) => {
    try {
        const response = await deleteTemplate( id );
        return response;
    } catch (err) {
        console.log("err to delete template "+ err)
        return null;
    }
};

const editTemplateFromDatabase = async ( templateData ) => {
    try {
        const response = await updateTemplate( templateData );
        return response;
    } catch (err) {
        console.log("err to edit template "+ err)
        return null;
    }
};

export {
    create,
    getTemplatesFromDatabase,
    deleteTemplateFromDatabase,
    editTemplateFromDatabase
 };